// Permisos RBAC de Mensajes al cliente. La pantalla toca DOS dominios de `loan-config-business`:
// las plantillas (`messages.template.*`) y los parámetros donde vive la ficha (`loan.parameter.*`).

/** Claves del dominio. `string` y no `PermissionKey`: el generado del rbac no las trae. */
export const CUSTOMER_MESSAGES_PERMISSIONS = {
    templateRead: 'messages.template.read',
    templateWrite: 'messages.template.write',
    parameterRead: 'loan.parameter.read',
    parameterUpdate: 'loan.parameter.update',
    parameterAudit: 'loan.parameter.audit',
    send: 'messages.message.send',
    regulatorySend: 'loan.notice.regulatory.send',
} as const;

export type CustomerMessagesPermissionKey =
    (typeof CUSTOMER_MESSAGES_PERMISSIONS)[keyof typeof CUSTOMER_MESSAGES_PERMISSIONS];

/** Con `false` todo queda permitido. Prendido desde que la pantalla lee del backend real. */
export const CUSTOMER_MESSAGES_PERMISSIONS_ENFORCED = true;

export interface CustomerMessagesAbilities {
    canRead: boolean;
    canUpdate: boolean;
    canViewHistory: boolean;
    canSend: boolean;
    /** Mandar el CAT o el aviso de privacidad a toda la cartera viva (PM-075 y PM-076). */
    canSendRegulatory: boolean;
}

/**
 * Qué puede hacer el rol en la pantalla. Leer y guardar necesitan los DOS permisos de su par: con
 * uno solo la pantalla pasa el gate y se estrella contra un 403 del endpoint que le falta.
 */
export function resolveCustomerMessagesAbilities(
    grantedPermissions: ReadonlySet<string>,
    enforce: boolean = CUSTOMER_MESSAGES_PERMISSIONS_ENFORCED,
): CustomerMessagesAbilities {
    if (!enforce) {
        return {
            canRead: true,
            canUpdate: true,
            canViewHistory: true,
            canSend: true,
            canSendRegulatory: true,
        };
    }
    const has = (key: CustomerMessagesPermissionKey) => grantedPermissions.has(key);
    return {
        canRead:
            has(CUSTOMER_MESSAGES_PERMISSIONS.templateRead) &&
            has(CUSTOMER_MESSAGES_PERMISSIONS.parameterRead),
        canUpdate:
            has(CUSTOMER_MESSAGES_PERMISSIONS.templateWrite) &&
            has(CUSTOMER_MESSAGES_PERMISSIONS.parameterUpdate),
        canViewHistory: has(CUSTOMER_MESSAGES_PERMISSIONS.parameterAudit),
        canSend: has(CUSTOMER_MESSAGES_PERMISSIONS.send),
        canSendRegulatory: has(CUSTOMER_MESSAGES_PERMISSIONS.regulatorySend),
    };
}
